import { useNavigate } from "react-router-dom";

export type UsersTab = "users" | "roles";

interface UsersNavigationProps {
	activeTab: UsersTab;
}

export function UsersNavigation({ activeTab }: UsersNavigationProps) {
	const navigate = useNavigate();

	const tabStyle = (active: boolean) => ({
		background: active ? "var(--crm-primary, #2563eb)" : "#f1f5f9",
		color: active ? "#ffffff" : "#475569",
		border: "none",
		borderRadius: "8px",
		padding: "8px 16px",
		fontWeight: 600,
		cursor: "pointer",
		transition: "all 0.2s ease",
	});

	return (
		<div style={{ display: "flex", gap: "10px", marginBottom: "24px", flexWrap: "wrap" }}>
			<button
				type="button"
				style={tabStyle(activeTab === "users")}
				onClick={() => navigate("/users")}
			>
				Foydalanuvchilar
			</button>
			<button
				type="button"
				style={tabStyle(activeTab === "roles")}
				onClick={() => navigate("/roles")}
			>
				Rollar va Huquqlar
			</button>
		</div>
	);
}
